import React from 'react'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import './index.scss'

export interface OverclaimConfirmationPopupProps {
    onClickConfirm: () => void
    confirmButtonText: string
    onClickCancel?: () => void
}
const OverclaimConfirmationPopup = (props: OverclaimConfirmationPopupProps) => {
    const { onClickConfirm, confirmButtonText, onClickCancel } = props
    return (
        <ConfirmationPopup
            title={
                'Submitting your current share percentage will put total shares for this work over 100%, which moves it\n' +
                'into overclaim conflict.'
            }
            confirmButtonText={confirmButtonText}
            cancelButtonText="Back"
            onCancel={onClickCancel}
            onConfirm={onClickConfirm}
        >
            <p>
                Full information about resolving overclaims can be found
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://help.themlc.com/en/support/what-is-an-overclaim-and-how-do-i-resolve-one-using-the-overclaims-tool"
                >
                    {' '}
                    here.{' '}
                </a>
                Click Back to edit your share percentage or Continue to continue submitting with your current share
                percentage and moving the work into overclaim conflict.
            </p>
        </ConfirmationPopup>
    )
}

export default OverclaimConfirmationPopup
